// VS Automobilzentrum Kurumsalfarben — Quelle: vs-automobilzentrum.de
export const C = {
  primary:     '#ffc000',   // VS Gold — Accent, aktive Nav, Buttons
  primaryDark: '#e0a800',   // Hover
  primarySoft: '#fff8e1',   // heller Gold-Hintergrund (Badges, Icon-Boxen)
  onPrimary:   '#111111',   // Text auf Gold — IMMER dunkel

  dark:        '#0d1b2a',   // Sidebar, Display-Hintergrund, Modal-Header
  darkSoft:    '#16263a',   // Karten/Zeilen auf dunklem Grund

  text:        '#1e293b',
  textMuted:   '#64748b',
  textFaint:   '#94a3b8',

  bg:          '#f1f5f9',
  card:        '#ffffff',
  border:      '#e2e8f0',

  danger:      '#dc2626',
  dangerBg:    '#fef2f2',
  warn:        '#f59e0b',
  warnBg:      '#fffbeb',
  success:     '#16a34a',
  successBg:   '#f0fdf4',
  fastcars:    '#7c3aed',
  fastcarsBg:  '#faf5ff',
  info:        '#2563eb',
  infoBg:      '#eff6ff',
}
